import customLinksApi from "@api/customLinks" //eslint-disable-line
import Vue from 'vue'

export default {
    namespaced: true,
    state: {
        loading: {
            customLinksList: false,
        },
        errors: {
            customLinksList: null,
        },
        customLinksList: [],
        customLink: {},
        wizardStartOver: true,
    },
    getters: {
        customLink: state => state.customLink,
        customLinksList: state => state.customLinksList,
        getLoadingState: state => name => state.loading[name],
        getErrorState: state => name => state.errors[name],
        wizardStartOver: state => state.wizardStartOver,
    },
    mutations: {
        setError(state, error) {
            Vue.set(state.errors, error.name, error.value)
        },
        setLoadingState(state, loading) {
            Vue.set(state.loading, loading.name, loading.value)
        },
        setCustomLinksList(state, customLinks) {
            Vue.set(state, 'customLinksList', customLinks)
        },
        setCustomLink(state, data) {
            const customLink = { ...data }
            Vue.set(state, 'customLink', customLink)
        },
        updateCustomLinkProperty(state, payload) {
            Vue.set(state.customLink, payload.property, payload.value)
        },
    },
    actions: {
        setCustomLinksList({ commit }) {
            commit('setLoadingState', { name: 'customLinksList', value: true })

            customLinksApi
                .getCustomLinks()
                .then(response => {
                    const { data } = response.data

                    commit('setCustomLinksList', data)
                })
                .catch(() => {
                    commit('setError', {
                        name: 'customLinksList',
                        value: true,
                    })
                })
                .finally(() => {
                    commit('setLoadingState', { name: 'customLinksList', value: false })
                })
        },
        clearError({ commit }, name) {
            commit('setError', {
                name,
                value: null,
            })
        },
        clearCustomLink({ commit }) {
            commit('setCustomLink', {
                uuid: '',
                name: '',
                tags: '',
                client_uuid: null,
                category_uuid: null,
                product_uuid: null,
                channel_uuid: null,
                product: {},
                category: {},
                notes: '',
                fallback_url: null,
            })
        },
        updateCustomLinkProperty({ commit }, payload) {
            commit('updateCustomLinkProperty', payload)
        },
        initializeCustomLinksManager({ dispatch }) {
            dispatch('setCustomLinksList')
        },
        storeCustomLink({ commit, state }) {
            commit('setLoadingState', { name: 'customLinkSave', value: true })
            commit('setError', { name: 'customLinkSave', value: false })
            return customLinksApi
                .addCustomLink(state.customLink)
                .catch(() => {
                    commit('setError', { name: 'customLinkSave', value: true })
                })
                .finally(() => {
                    commit('setLoadingState', { name: 'customLinkSave', value: false })
                })
        },
        updateCustomLink({ commit, state }) {
            commit('setLoadingState', { name: 'customLinkSave', value: true })
            commit('setError', { name: 'customLinkSave', value: false })
            return customLinksApi
                .updateCustomLink(state.customLink.uuid, state.customLink)
                .catch(() => {
                    commit('setError', { name: 'customLinkSave', value: true })
                })
                .finally(() => {
                    commit('setLoadingState', { name: 'customLinkSave', value: false })
                })
        },
        getCustomLink({ commit }, uuid) {
            commit('setLoadingState', { name: 'customLink', value: true })

            return customLinksApi
                .getCustomLink(uuid)
                .then(response => {
                    const { data } = response.data

                    commit('setCustomLink', data)
                })
                .catch(() => {
                    commit('setError', {
                        name: 'customLink',
                        value: true,
                    })
                })
                .finally(() => {
                    commit('setLoadingState', { name: 'customLink', value: false })
                })
        },
    },
}
